import React, { Component } from "react";
import PropTypes from "prop-types";
import { Dropdown, MenuItem, Glyphicon } from "react-bootstrap";

import NotificationBadge from "react-notification-badge";
import { Effect } from "react-notification-badge";
import messgae from "../../Assets/message.svg";
import "./style.css";

export default class HeaderMessage extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.handleToggle = this.handleToggle.bind(this);
  }

  render() {
    return (
      <div className="no-focus-outline" onClick={() => this.handleToggle()}>
        <div className="dropdown btn-group">
          <div className="hsg-header-alert-root" bsrole="toggle">
            {/* <div style = {{display:'flex', flexDirection: 'column'}}>
              <div>
                <img src={messgae} />
                <NotificationBadge
                  count={this.props.count}
                  effect={Effect.SCALE}
                  style={{ fontSize: 8, top: 2, padding: 2 }}
                />
              </div>
              <div style = {{fontSize:10, fontWeight: 700, marginTop:5, marginLeft:-9 }}>MESSAGES</div>
            </div> */}
          </div>
        </div>
      </div>
    );
  }

  handleToggle() {
    this.props.onMessageIcon();
  }
}

HeaderMessage.propTypes = {};



// WEBPACK FOOTER //
// ./src/Components/HeaderMessage/index.js